import React from 'react';
import Heading2 from '@Components/heading_2/view';
import Heading3 from '@Components/heading_3/view';

import s from '../styles/DetailContent.module.css';

const Knowledge3 = () => {
    return (
        <div className={s.wrapper}>
            <section className={s.section}>
                <Heading2 title='ゴルフ会員権の名義書換について' fontWeight={700} />
                <Heading3 title='ゴルフ会員権名義書換とは' />
                <p>
                    ゴルフ会員権購入時、法人会員権の利用者の変更時、旧名義人から名義を変更する必要があります。名義を書き換えてメンバー登録されることではじめてプレーが可能となり、施設利用権や様々なサービスを受ける権利が発生します。
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='ゴルフ会員権の名義書換料について' fontWeight={700} />

                <Heading3 title='名義書換料金とは' />
                <p>
                    名義書換手続きにかかる費用で、名義書換を認めているゴルフ場は、書換の際に新入会者より徴収します。また、ゴルフ会員権を売却する方は新たに名義書換料を支払う必要はありません。
                    <br />
                    名目は会員権の名義を変更するために請求するゴルフ場の手数料となります。年会費と共にゴルフ場の大きな収入源となっています。名義書換料はゴルフ場に支払う手数料となりますので入会預託金などとは異なり、返還は受けられません。
                </p>

                <Heading3 title='名義書換料はいくらか' />
                <p>
                    名義書換料はゴルフ場によって異なり、10万円から100万円程度が相場となっています。（当社では分かりやすいように消費税は内税価格でご案内しています。）
                    <br />
                    しかし、なかには１０００万円以上かかる名義書換料の高いゴルフ場も存在します。
                </p>

                <Heading3 title='名義書換料は経費になるか' />
                <p>
                    ゴルフ会員権を取得した際の仕訳については、名義書換料を含むゴルフ会員権の取得費は経費として処理出来ず、資産計上する必要があります。（税務の上では、会員権の取得価額には名義書換料のほか入会金、預託金、売買手数料が含まれ、会員権と同じ勘定科目になります。）
                    <br />
                    ただし、従来から所有しているゴルフ会員権を名義書換する場合は、経費（交際費）として会計処理することになるため、処理の違いに注意が必要です。具体的には法人会員記名式でその記名者が特定の役職者に限られ、当該役職者の転任により名義人を書き換える必要が発生した場合などが該当します。
                    <br />
                    なお、退会や会員権の譲渡により損失が生じた場合には売却損を計上し、保有中の会員権価値が大きく下落した場合には減損処理が必要となり、減損損失として計上することになります。
                    <br />
                    名義書換料の勘定科目と具体的な仕訳例については
                    <a href='/knowledge/36'>名義書換料の勘定科目・仕訳完全ガイド</a>
                    で詳しくご紹介しています。
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='ゴルフ会員権は名義書換すれば相続される' fontWeight={700} />

                <Heading3 title='名義書換の流れ' />
                <p>
                    被相続人から名義書換を行いメンバーとしてプレーすることが可能です。
                    <br />
                    名義書換の大まかな流れは以下の通りとなります。
                    <br />
                    1.必要書類を提出
                    <br />
                    2.入会審査
                    <br />
                    3.名義書換料の振込み
                    <br />
                    <br />
                    <strong>
                        <u>１）名義書換の為のゴルフ場所定用紙への記入・必要書類の準備</u>
                    </strong>
                    <br />
                    まず、相続に関する必要書類をご準備し、ゴルフ場ごとに定められた名義書換の為の規定用紙をご記入いただき、ゴルフ場へ提出します。
                    詳しくは当社もしくはゴルフ場にお問合せいただき必要事項をご記入の上ご提出ください。
                    <br />
                    <br />
                    <strong>【必要書類について】</strong>
                    <br />
                    〔戸籍謄本もしくは除籍謄本〕
                    <br />
                    被相続人と相続人の関係を証明するものです。被相続人が属していた戸籍に記されている方々が皆、既に亡くなられていたり、婚姻や転籍などでその戸籍から除かれたりしていた場合は、それを証明する謄本が必要となります。
                    <br />
                    <br />
                    〔相続同意書〕
                    <br />
                    被相続人所有のゴルフ会員権を代表相続人へ相続することを明らかにした書類が必要になります。被相続人所有のゴルフ会員権（ゴルフ場毎）は基本的に1人にしか相続ができない為、代表者も含め、全相続人の住所、氏名、実印押印等を記載した相続同意書を作成する必要があります。相続同意書はゴルフ場によって提出用紙が異なります。指定のフォーマットを用意しているゴルフ場もあれば、相続人の方が作成して提出すればよしとしているゴルフ場もあります。
                    <br />
                    <br />
                    〔印鑑証明書〕
                    <br />
                    相続同意書に押印した全相続人の印鑑証明書です。
                    <br />
                    <br />
                    〔改製原戸籍謄本〕
                    <br />
                    相続人が実際に何人いるかを確認する為の書類です。被相続人の出生から亡くなられるまでの履歴が必要です。
                    <br />
                    <br />
                    <strong>
                        <u>２）ゴルフ場による入会審査</u>
                    </strong>
                    <br />
                    円滑な名義書換が行われるか否かは、ゴルフ場の設けている入会条件によります。入会条件には年齢制限、当該クラブ会員からの推薦・紹介、他クラブ在籍の有無などが挙げられます。相続の場合にはそうした諸条件が緩和・免除されるケースもありますが、相続人の方がゴルフ場の規定する条件を満たすことが出来ない場合、入会承認が下りないこともあり得ます。
                    <br />
                    <br />
                    <strong>
                        <u>３）承認後名義書換料の振込</u>
                    </strong>
                    <br />
                    ゴルフ場指定の名義書換料をゴルフ場に支払います。名義書換料は会員種別（正会員、平日会員、週日会員、婦人会員等）によって金額が異なります。また、相続による名義書換の場合は通常の名義書換料よりも割引されるケースもあります。
                    <br />
                    <br />
                </p>

                <Heading3 title='相続税について' />
                <p>
                    ゴルフ会員権を相続した場合には相続税がかかります。評価額はゴルフ会員権業者に確認するのが一般的です。相続したゴルフ会員権は相続財産総額の一部となり、取引相場の有無によって評価方法が異なります。市場で取引相場がある場合は、通常取引相場の７０％に相当する額が相続税算出時の評価額となります。
                    <br />
                    市場で取引相場がない場合は預託金を基準に評価額を算出します。
                    <br />
                    個人会員であっても法人の資産となっているケースがあります。なぜならば法人会員としての入会が認められず、やむなく個人として入会した場合をさします。この会員権は法人の資産に該当するので売却時の損金は該当法人の法人税を算出する際に損失としての計上が可能となります。
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='まとめ' fontWeight={700} />
                <p>
                    上述のようにゴルフ会員権を新たに所有する方が、ゴルフ場に対して支払う名義書換料はゴルフ場によって異なります。また、相続時の名義書換料は通常取引時の名義書換料（市場での第三者間による取引）よりも安く設定されているケースもあり、こちらもゴルフ場によって様々です。
                    <br />
                    より詳細な情報をご希望の方は、お気軽に当社までお問合せください。
                    <br />
                    そもそもゴルフ会員権とは何かという基礎知識は<a href='/knowledge/8'>こちら</a>をご覧ください。
                </p>
            </section>
        </div>
    );
};

export default Knowledge3;
